export class RefineryInfo {
    public facility_id: string;
    public name: string;
    public padd_region: string;
    public region: string;
    public state: string;
    public fema_region: string;

    public capacity_at_start_date: number;
    public capacity_at_end_date: number;
    public impacted_capacity_at_start_date: number;
    public impacted_capacity_at_end_date: number;

    public planned_outage_count: number;
    public refinery_alert_count: number;

    public unit_ids: string;
    public units_offline: number;
    public units_online: number;

    public total_units: number;
    public status: 'Online' | 'Reduced Capacity' | 'Idled';

    public iconStatusClass: string;
    public iconName: string;

    constructor(input?: RefineryInfo) {
        this.facility_id = input.facility_id;
        this.name = input.name;
        this.padd_region = input.padd_region;
        this.region = input.region;
        this.state = input.state;
        this.fema_region = input.fema_region;
        this.capacity_at_start_date = input.capacity_at_start_date;
        this.capacity_at_end_date = input.capacity_at_end_date;
        this.impacted_capacity_at_start_date = input.impacted_capacity_at_start_date;
        this.impacted_capacity_at_end_date = input.impacted_capacity_at_end_date;
        this.planned_outage_count = input.planned_outage_count;
        this.refinery_alert_count = input.refinery_alert_count;
        this.unit_ids = input.unit_ids;
        this.units_offline = input.units_offline;
        this.units_online = input.units_online;

        this.total_units = this.units_offline + this.units_online;

        if (this.units_online === this.total_units) {
            this.status = 'Online';
            this.iconStatusClass = 'online';
            this.iconName = 'check-fat';
        } else if (this.units_online >= 1 && this.units_offline >= 1) {
            this.status = 'Reduced Capacity';
            this.iconStatusClass = 'impacted';
            this.iconName = 'warning';
        } else if (this.units_offline === this.total_units) {
            this.status = 'Idled';
            this.iconStatusClass = 'offline';
            this.iconName = 'prohibit';
        }
    }
}
